import { render, staticRenderFns } from "./AddTermModal.vue?vue&type=template&id=043777b1&scoped=true&"
import script from "./AddTermModal.vue?vue&type=script&lang=js&"
export * from "./AddTermModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTermModal.vue?vue&type=style&index=0&id=043777b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043777b1",
  null
  
)

export default component.exports